<template>
  <div class="file_view">
    <el-dialog
      title="查看签收单"
      :visible.sync="fileVisible"
      width="30%"
      :before-close="handleClose"
      @open="handleFileType"
    >
      <div>
        <div
          v-if="srcList.length > 0"
          class="images_view"
          style="
            display: flex;
            flex-direction: row;
            gap: 10px;
            margin-bottom: 10px;
            overflow-x: auto;
          "
        >
          <el-image
            v-for="(item, index) in srcList"
            :key="index"
            style="
              width: 100px;
              height: 100px;
              border-radius: 10px;
              min-width: 100px;
            "
            :src="item"
            :preview-src-list="srcList"
          >
          </el-image>
        </div>
        <el-table
          v-if="fileList.length > 0"
          :data="fileList"
          stripe
          style="width: 100%"
          border
        >
          <el-table-column type="index" width="60" label="序号">
          </el-table-column>
          <el-table-column
            prop="fileName"
            show-overflow-tooltip
            label="文件名称"
          >
          </el-table-column>
          <el-table-column label="操作" width="100px">
            <template slot-scope="scope">
              <el-button
                type="warning"
                @click="downloadFile(scope.row)"
                round
                icon="el-icon-download"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {

  props: {
    fileVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    tableData: {
      type: Array,
      default: () => { return [] },
      required: true
    }
  },
  data() {
    return {
      // 图片链接列表
      srcList: [],
      // 文件链接列表
      fileList: [],
      // // 表格数据
      // tableData: [{
      //   flieName: '合同1',
      //   fileUrl: ''
      // }],
      pdfUrl: '',
      docxUrl: "",
      previewFile: false
    }
  },
  methods: {
    /**
     * 处理文件类型
     * */
    handleFileType() {
      // 图片白名单
      const imageTypes = ['jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'jpg', 'image'];
      this.srcList = this.tableData.filter(file => imageTypes.includes(file.fileType)).map(item => { return item.fileUrl });
      this.fileList = this.tableData.filter(file => !imageTypes.includes(file.fileType));
    },
    /**
     * 错误打开信息
     * */
    onError() {

    },
    /**
     * 开启文件弹窗
     * @param row 文件信息
     * */
    openPreDia(row) {
      const match = /\.([^.]+)$/.exec(row.filename);
      if (!!match && match[1] !== 'pdf') {
        this.$message.warning("非pdf文件暂不支持预览,请下载至本地查看")
        return
      }
      this.pdfUrl = row.path
      this.previewFile = true
    },
    /**
     * 关闭文件弹窗
     * */
    closePreDia() {
      this.previewFile = false
    },
    /**
     * 关闭文件预览弹窗
     * */
    handleClose() {
      this.$emit("closeFileDia", false)
    },
    /**
     * 文件预览
     * */
    onRendered() {

    },
    /**
     * 文件下载
     * */
    downloadFile(row) {
      window.open(row.fileUrl)
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .is-round {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px !important;
}

::v-deep .el-table .cell {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/PersonalCenter/components/viewOrder.vue